import injectSheet from 'react-jss'
import styles from './app.styles'
import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Lessons from '../pages/lessons/lessons'
import Header from './header/header'
import {
  UserProvider,
  UserInspector,
  useMe
} from 'pobble-components/dist/pobble-user'
import { ConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { ToastContainer } from 'pobble-components/dist/toast'
import EnvironmentLine from 'pobble-components/dist/environment-line'
import SharedPreview from '../pages/shared-preview/shared-preview.container'
import PageNotFound from 'pobble-components/dist/page-not-found'
import { SubscriptionProvider } from 'pobble-components/dist/subscriptions'
import Lesson from '../pages/lesson/lesson.container'
import DirectPresent from '../pages/direct-present/direct-present'
import PresentModeProvider from '../pages/direct-present/present-mode.provider'
import PrintPreview from '../pages/print-preview/print-preview'
import { ErrorBoundary } from 'pobble-components/dist/error-boundary'
import { Prompt } from '../pages/prompt/prompt'
import { Calendar } from '../pages/prompt/calendar/calendar'
import { PublicPreview } from '../pages/public-preview/public-preview'
import { TeacherPreview } from '../pages/teacher-preview/teacher-preview'
import { Topics } from '../pages/prompt/topics/topics'
import { Weekly } from '../pages/prompt/weekly/weekly'
import { WorksPage } from '../pages/works/works'
import { Search } from '../pages/prompt/search/search'
import { Copy } from '../pages/copy/copy'
import posthog from 'posthog-js'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'

const APP_PATH = process.env.REACT_APP_PATH || '/'

function PostHogIdentity() {
  const { me } = useMe()
  const {
    hasAccessToTL,
    freeTrial,
    validPaymentMethod,
    cancelsAtTrialEnd
  } = useSubscriptionDetails()

  useEffect(
    () => {
      if (me) {
        const account = me.account
        posthog.identify(account.id, {
          email: account.email_identity?.email,
          name: account.full_name,
          role: account.role_in_life,
          createdAt: account.created_at,
          countryCode: account.country_code,
          hasAccessToTL,
          freeTrial,
          validPaymentMethod,
          cancelsAtTrialEnd
        })
        posthog.capture('landed on lesson spa', {
          url: window.location.href
        })
      }
    },
    [me, hasAccessToTL, freeTrial]
  )

  return null
}

const App = ({ classes, me, meError }) => (
  <UserProvider
    fetchMe={() => {
      if (me) {
        return Promise.resolve(me)
      } else {
        return Promise.reject(meError)
      }
    }}>
    <PostHogIdentity />
    <SubscriptionProvider>
      <EnvironmentLine />
      <Router basename={APP_PATH}>
        <PresentModeProvider>
          <Header />
          <ErrorBoundary>
            <Switch>
              <Route path="/preview/:id" component={PublicPreview} />
              <Route path="/teachers/:id" component={TeacherPreview} />
              <UserInspector
                authRedirect={false}
                haveRights={me => me.account.policy.can_use_presentations}>
                <div className={classes.appHolder}>
                  <Switch>
                    <Route exact path="/prompt" component={Prompt} />
                    <Route exact path="/prompt/weekly" component={Weekly} />
                    <Route exact path="/prompt/topics" component={Topics} />
                    <Route exact path="/prompt/search" component={Search} />
                    <Route
                      exact
                      path="/prompt/search/:searchTerm"
                      component={Search}
                    />
                    <Route exact path="/prompt/calendar" component={Calendar} />
                    <Route
                      exact
                      path="/prompt/topics/:year"
                      component={Topics}
                    />
                    <Route exact path="/prompt/:id" component={Prompt} />
                    <Route exact path="/copy/:copyId" component={Copy} />
                    <Route
                      exact
                      path={['/', '/new', '/archived', '/shared']}
                      component={Lessons}
                    />
                    <Route path="/lesson/:id" component={Lesson} />
                    <Route path="/shared/:id" component={SharedPreview} />
                    <Route path="/present/:id" component={DirectPresent} />
                    <Route
                      exact
                      path="/works/:filter/:age/"
                      component={WorksPage}
                    />
                    <Route
                      exact
                      path="/works/:filter/:age/:search"
                      component={WorksPage}
                    />
                    <Route path="/print-preview/:id" component={PrintPreview} />
                    <Route component={PageNotFound} />
                  </Switch>
                </div>
              </UserInspector>
            </Switch>
          </ErrorBoundary>
          <ConfirmationDialog />
          <ToastContainer />
        </PresentModeProvider>
      </Router>
    </SubscriptionProvider>
  </UserProvider>
)

export default injectSheet(styles)(App)
